import baseRoute from '../baseRoute';

export default `${baseRoute}/smallTool` as const;
